export { inject as Inject } from 'inversify-props';
